import { useState } from 'react';

export const useHelpSection = () => {
  const [isEditing, setIsEditing] = useState(false);

  return {
    isEditing,
    setIsEditing
  };
};
